import { schema } from 'normalizr';

const emailsSchema = new schema.Entity('script_templates');

export default {
  emailsSchema,
};
